import React, { useState, useEffect } from "react";
import "./Payout.scss"; // Make sure to import your CSS file
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, FormCheck, Row } from "react-bootstrap";
import { Formik } from "formik";
import { CustomCard } from "../../CustomCard";

export const PayoutCard = ({ data, onCheckboxChange, isSelected }) => {
  const {
    svcf_user_profile_id,
    svcf_provider_name,
    s_status_cd,
    svc_provider_cost_amt,
    svc_provider_local_cost_amt,
    order_count,
    svcf_name,
    bank_acct_holder_name,
    svc_bank_account,
    svc_bank_bank_name,
    bank_routing_no,
  } = data;

  const { refsdata } = useSelector((state) => state.refstypes);
  const xchange_rate = refsdata.usr?.iso_currency_xchng || [];

  const svc_provider_local_cost_amtf = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(svc_provider_local_cost_amt);

  const svc_provider_cost_amtf = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(svc_provider_cost_amt);

  const handleCheckboxChange = (e) => {
    onCheckboxChange(svcf_user_profile_id, e.target.checked);
  };

  return (
    <Formik
      initialValues={{
        paySelected: false,
      }}
      onSubmit={(values) => {}}
    >
      {({ touched, errors, values, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <CustomCard className="facility patient-card">
            <div
              className="d-flex justify-content-between align-items-center !pb-3 !mb-4"
              style={{ borderBottom: "1px solid #E7E7E9" }}
            >
              <div className="flex w-full justify-between">
                <div>
                  <h6 className="card-title mb-0">{svcf_provider_name}</h6>
                  <small> #{svcf_user_profile_id}</small>
                </div>

                <div className="">
                  <label
                    className="!text-sm"
                    style={{
                      color: isSelected ? "green" : "black",
                    }}
                  >
                    <input
                      name="paySelected"
                      type="checkbox"
                      className="mr-2"
                      onChange={handleCheckboxChange}
                      checked={isSelected}
                    />
                    {isSelected ? "Selected for PAYMENT" : "Pay this provider"}
                  </label>
                </div>
              </div>
            </div>

            <div className="row gap-y-[18px]">
              <div className="col-6">
                <small>Account Holder:</small>
                <p className="truncate mb-0">
                  {" "}
                  {bank_acct_holder_name
                    ? bank_acct_holder_name
                    : svcf_provider_name}
                </p>
              </div>

              <div className="col-6">
                <small>Bank:</small>
                <p className="truncate mb-0">{svc_bank_bank_name || "N/A"}</p>
              </div>

              <div className="col-6">
                <small>Account# :</small>
                <p className="truncate mb-0">{svc_bank_account || "N/A"}</p>
              </div>

              <div className="col-6">
                <small>Service Facility :</small>
                <p className="truncate mb-0">{svcf_name || "N/A"}</p>
              </div>

              <div className="col-6">
                <small>Total Orders :</small>
                <p className="truncate mb-0">{order_count || "N/A"}</p>
              </div>

              <div className="col-6">
                <small>Payout Amount (USD) :</small>
                <p className="truncate mb-0">
                  {svc_provider_cost_amtf || "N/A"}
                </p>
              </div>

              <div className="col-6">
                <small>{xchange_rate[0]?.iso_curr_name} rate @</small>
                <p className="truncate mb-0">
                  {xchange_rate[0]?.xchng_rate || "N/A"}
                </p>
              </div>

              <div className="col-6">
                <small>Local Payout Amount :</small>
                <p className="truncate mb-0">{svc_provider_local_cost_amtf}</p>
              </div>
            </div>
          </CustomCard>
        </Form>
      )}
    </Formik>
  );
};
